import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import Button from 'src/component/Button';
import IconSave from 'src/component/Icon/IconSave';
import { Store } from 'src/store';
import sendRequestDesignDataPostMessageToSaveToDrafts
  from 'src/store/app/operation/sendRequestDesignDataPostMessageToSaveToDrafts';
import getEditorMode from 'src/store/app/selector/getEditorMode';
import { EDITOR_MODE } from 'src/store/app/types';
import getCanDesignBeSaved from 'src/store/design/selector/getCanDesignBeSaved';
import hasDesignStructureChanged from 'src/store/design/selector/hasDesignStructureChanged';
import isDesignLoaded from 'src/store/design/selector/isDesignLoaded';
import isDesignLoading from 'src/store/design/selector/isDesignLoading';
import isDesignSaving from 'src/store/design/selector/isDesignSaving';
import isPublicDesign from 'src/store/design/selector/isPublicDesign';

interface OwnProps {
  showLabel: boolean;
}

interface Props extends OwnProps {
  isCustomerDesign: boolean;
  isSaving: boolean;
  isLoading: boolean;
  isLoaded: boolean;
  canSave: boolean;
  hasDesignChanged: boolean;
  draftsUrl?: string;
  editorMode: EDITOR_MODE;
  dispatch: ThunkDispatch<Store, void, AnyAction>;
}

const SaveToDraftsButton = (
  {
    dispatch,
    isCustomerDesign,
    isSaving,
    isLoading,
    isLoaded,
    canSave,
    hasDesignChanged,
    editorMode,
    showLabel,
  }: Props,
) => {
  const { t } = useTranslation();

  if (
    !isCustomerDesign
    || !isLoaded
    || !hasDesignChanged
    || isLoading
    || editorMode !== EDITOR_MODE['create-new']
  ) {
    return null;
  }

  const onClick = () => {
    dispatch(sendRequestDesignDataPostMessageToSaveToDrafts());
  };

  return (
    <Button
      onClick={onClick}
      withPadding
      primary
      disabled={isSaving || !canSave}
      icon={<IconSave />}
      text={showLabel ? t('opeh_top-bar_save-to-drafts') : null}
    />
  );
};

const mapStateToProps = (store: Store) => ({
  isSaving: isDesignSaving(store),
  isLoading: isDesignLoading(store),
  isLoaded: isDesignLoaded(store),
  isCustomerDesign: !isPublicDesign(store),
  hasDesignChanged: hasDesignStructureChanged(store),
  editorMode: getEditorMode(store),
  canSave: getCanDesignBeSaved(store),
});

export default connect(mapStateToProps)(SaveToDraftsButton);
